package one.devsbox.www.provider

import androidx.compose.runtime.staticCompositionLocalOf
import one.devsbox.shared.ads.SharedIO.MediaCore
import one.devsbox.www.provider.NavigationCallbackProvider.Task.Media.MediaRequest
import one.devsbox.www.provider.NavigationCallbackProvider.Task.Media.MediaResponse
import one.devsbox.www.tools.root
import one.devsbox.www.ui.resources.ArgsListingResource
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.navTo_ListingResourcesUI

@Suppress("unused")
val LocalNavigationCallbackProvider =
    staticCompositionLocalOf<NavigationCallbackProvider> { error("NavigationCallbackProvider is not implemented by CompositionLocalProvider") }

@Suppress("UNCHECKED_CAST")
class NavigationCallbackProvider {

    interface Collector {
        fun pickMedia(nav: Navigation, key: String, type: Int, orientation: Int, openInRootNode: Boolean = true)

        fun <T : Task> get(key: String, body: (T) -> Unit)
    }

    interface Publisher {
        fun <T : Task> publish(key: String, task: T)

        operator fun <T : Task> get(key: String): T?
    }

    interface ImplTask<X : ImplTask.Request, Y : ImplTask.Response> {
        val request: X
        var response: Y?

        interface Request
        interface Response

    }

    private val tasks = mutableMapOf<String, Task>()

    sealed interface Task {

        data class Media(
            override val request: MediaRequest,
            override var response: MediaResponse? = null
        ) : Task, ImplTask<MediaRequest, MediaResponse> {
            data class MediaRequest(
                /**
                 * @see one.devsbox.shared.files.ResourceType
                 */
                val type: Int,
                /**
                 * @see one.devsbox.shared.files.RotationType
                 */
                val orientation: Int
            ) : ImplTask.Request

            data class MediaResponse(
                override var id: Long,
                override var name: String,
                override var aspectRatio: String,
                /**
                 * @see one.devsbox.shared.files.ResourceType
                 */
                override var type: Int,
                override var duration: Long,
                override var width: Int,
                override var height: Int,
            ) : ImplTask.Response, MediaCore
        }
    }


    val collector = object : Collector {
        override fun pickMedia(nav: Navigation, key: String, type: Int, orientation: Int, openInRootNode: Boolean) {
            tasks[key] = Task.Media(
                MediaRequest(
                    type = type,
                    orientation = orientation
                )
            )
            if (openInRootNode) nav.root().navTo_ListingResourcesUI(ArgsListingResource(key))
            else nav.navTo_ListingResourcesUI(ArgsListingResource(key))
        }

        override fun <T : Task> get(key: String, body: (T) -> Unit) {
            tasks[key]?.also { task ->
                runCatching {
                    @Suppress("UNCHECKED_CAST")
                    body(task as T)
                }.onFailure { it.printStackTrace() }
                tasks.remove(key)
            }
        }

    }

    val publisher = object : Publisher {
        override fun <T : Task> publish(key: String, task: T) {
            tasks[key] = task

        }

        override fun <T : Task> get(key: String): T? = tasks[key] as T?
    }


}